export const getSupplementsApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/supplement${queryString ? `?${queryString}` : ""}`;
};

export const deleteAttachment = (slug) => {
    return `lease/supplement/${slug}/attachments`
}

export const getSupplementDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/supplement`;
}

export const addSupplementApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/supplement`;
}
export const editSupplementApi = (params) => {
    return `/lease/${params?.leaseSlug}/supplement/${params?.slug}`;
}
export const supplementfileUploadPostApi = (supplement_slug) => {
    return `/get-pre-signed-url/supplement/${supplement_slug}`;
};

export const updateAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/supplement/${attachments_slug}`
}

export const deleteSupplementApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/supplement`;
}

